export const dateToDateNumber = (date: Date): number => {
  let dateNumber = 0;
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  dateNumber = day;
  dateNumber += month * 100;
  dateNumber += year * 10000;

  return dateNumber;
};

const textToDate = (text: string): Date | null => {
  const separators = ['/', '.', '-'];

  // Try to parse the date with each separator.
  for (const separator of separators) {
    const parts = text.split(separator).map((chunk) => chunk.trim());

    if (parts.length != 3) continue;

    let day = +parts[0];
    const month = +parts[1];
    let year = +parts[2];

    // If day is nonsensical, assume it's the year (swap day and year).
    if (day > 31) [day, year] = [year, day];

    // If year is less than 100, assume it's the 21st century.
    if (year < 100) year += 2000;

    const date = new Date(year, month - 1, day);

    // Make sure it is a valid date.
    if (date.getFullYear() != year) continue;
    if (date.getMonth() != month - 1) continue;
    if (date.getDate() != day) continue;

    return date;
  }

  return null;
};

export const textToDateRange = (text: string): [Date, Date] | null => {
  const separators = ['-', '–', '—', /--+/];

  // Try to parse the date range with each separator.
  for (const separator of separators) {
    const parts = text.split(separator);

    if (parts.length != 2) continue;

    let start = textToDate(parts[0]);
    let end = textToDate(parts[1]);

    if (!start || !end) continue;
    if (start.getTime() > end.getTime()) [start, end] = [end, start];

    return [start, end];
  }

  // Try parsing it as a single date otherwise.
  const date = textToDate(text);
  if (date) return [date, date];

  return null;
};
